import React from "react";

const WhiteTick: React.FC = () => {
  return (
    <svg
      width="24"
      height="28"
      viewBox="0 0 31 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.7091 28L8.03182 23.7333L2.95909 22.6667L3.45227 17.7333L0 14L3.45227 10.2667L2.95909 5.33333L8.03182 4.26667L10.7091 0L15.5 1.93333L20.2909 0L22.9682 4.26667L28.0409 5.33333L27.5477 10.2667L31 14L27.5477 17.7333L28.0409 22.6667L22.9682 23.7333L20.2909 28L15.5 26.0667L10.7091 28ZM14.0205 18.7333L23.25 10.6667L21.1364 8L14.0205 14.9333L10.9909 12.1333L9.01818 14L14.0205 18.7333Z"
        fill="white"
      />
    </svg>
  );
};

export default WhiteTick;
